import React from "react";
import {Button, Col, Divider, Form, Input, Row, Select, Tag} from "antd";
import MinusCircleOutlined from "@ant-design/icons/es/icons/MinusCircleOutlined";
import PlusOutlined from "@ant-design/icons/es/icons/PlusOutlined";
import {arrayHasDuplicates} from "../../../util/arrayUtils";

const {Option} = Select;

const ThirdStepProducts = ({softwareProducts, onProductsChange, editMode, initialValues, darkMode}) => {

    if (editMode) return <>
        <Divider orientation="left">Add Products (optional)</Divider>
        <Form.Item label={'Added Products'}>
            {initialValues.products?.map(i => <Tag className='software-product-tag' key={i.id}>
                {i.code}
            </Tag>)}
        </Form.Item>
    </>;

    return <>
        <Divider orientation="left">Add Products (optional)</Divider>

        <Form.List name="products" label={"Software Products"} rules={[
            {
                validator: async (_, products) => {
                    if (!products) return;
                    products = products.filter(p => !!p);
                    const submittedProductIds = products.map(i => i.softwareProductId);
                    if (arrayHasDuplicates(submittedProductIds)) {
                        return Promise.reject(new Error('You cannot add one software product multiple times!'));
                    }
                },
            },
        ]}>
            {(fields, {add, remove}, {errors}) => {
                return <>
                    {fields.map(({key, name, fieldKey, ...restField}) => {
                        return <Row>
                            <Col xs={24} lg={8}>
                            </Col>
                            <Col xs={24} lg={16}>
                                <Row key={key} style={{display: 'flex'}} align="baseline">
                                    <Form.Item style={{flex: 2}}
                                               {...restField}
                                               name={[name, 'softwareProductId']}
                                               fieldKey={[fieldKey, 'softwareProductId']}
                                               rules={[{required: true, message: 'Missing Software Product name'}]}
                                    >
                                        <Select disabled={editMode} showSearch
                                                optionFilterProp="children"
                                                placeholder={"Software Product"}
                                                dropdownClassName={darkMode && 'dark-mode'}
                                                onChange={onProductsChange}>
                                            {
                                                softwareProducts.map(({id, value}) => <Option key={id.toString()}
                                                                                              value={id}>{value}</Option>)
                                            }
                                        </Select>

                                    </Form.Item>
                                    <Form.Item style={{flex: 2}}
                                               {...restField}
                                               name={[name, 'code']}
                                               fieldKey={[fieldKey, 'code']}
                                               rules={[{required: true, message: 'Missing Code'}]}
                                    >
                                        <Input placeholder="Product Name"/>
                                    </Form.Item>
                                    <MinusCircleOutlined className='minus-icon' style={{width: 50}}
                                                         onClick={() => remove(name)}/>
                                </Row>
                            </Col>
                        </Row>

                    })}
                    <Form.Item label={' '} colon={false}>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                            Add {fields.length !== 0 ? 'another' : ''} Software Product
                        </Button>
                        <Form.ErrorList errors={errors}/>
                    </Form.Item>
                </>
            }}
        </Form.List>

    </>;
};

export default ThirdStepProducts;